import React, { useEffect, useState } from "react";
import {
  collection,
  // collectionGroup,
  onSnapshot,
  orderBy,
  query,
  limit,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { dbFinancialPromotions } from "../../../backend/firebaseConfig";
import "../../../css/Marketing/FinancialPromotions/FinancialPromotions.css";
import "../../../css/Marketing/FinancialPromotions/Dashboard/AdminApprovals.css";
import {
  getStorage,
  ref as storageRef,
  getDownloadURL,
} from "firebase/storage";
import { useParams } from "react-router-dom";
import RiskPill from "./buttons/RiskPill";
import {
  ATTEMPTS_SUBCOL,
  MediaReviewCard,
  buildAttachments,
  formatDateTime,
  formatSubmittedDate,
  formatSubmittedDateTime,
  
  getRiskLabel,
  getStatusColor,
  safeJson,
  toJsDate,
} from "./helpers/Helpers";
import StatusTag from "./buttons/StatusTag";
import { statusToChip } from "./utils/Utils";
import { ReactComponent as ExpandIcon } from "../../../assets/icons/financialPromotions/expand-arrow.svg";
import {
  FailedStatusOption,
  PassedStatusOption,
} from "./buttons/PassFailStatusOption";
import { useUserEmail } from "../../SignIn/UserEmailContext";
import CustomSelect from "../../../frontend/DesignSystem/Dropdowns/CustomSelect";
import { useAdviserListWithUnappointed } from "../../../context/Adviser/Utils/UnappointedAppointedAdviserEmailList";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";

export default function AdminSubmissionDetails() {
  const FP_REVIEW_ENDPOINT = "/fp/review";
  const FP_DECISION_EMAIL_ENDPOINT = "/fp/decision-email";
  const FP_API_BASE_URL = String(
    process.env.REACT_APP_FINANCIAL_PROMOTIONS_API_URL || "",
  )
    .trim()
    .replace(/\/$/, "");
  
  const [flagRatingsByAttemptId, setFlagRatingsByAttemptId] = useState({});
  const [savingFlagRatings, setSavingFlagRatings] = useState({});
  const [attempts, setAttempts] = useState([]);
  
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [isReapproving, setIsReapproving] = useState(false);
  const [reapprovalMessage, setReapprovalMessage] = useState("");

  const [detailsError, setDetailsError] = useState("");
  const [aiByAttemptId, setAiByAttemptId] = useState({});
  const [savingByAttemptId, setSavingByAttemptId] = useState({});
  const [savingFileDecisions, setSavingFileDecisions] = useState({});
  const [savingContentDecisions, setSavingContentDecisions] = useState({});
  const [expandedAttemptsById, setExpandedAttemptsById] = useState({});
  const [isReferenceCopied, setIsReferenceCopied] = useState(false);
  const [staffInfoNotes, setStaffInfoNotes] = useState("");
  // const [adviserOptions, setAdviserOptions] = useState([]);
  const [assignedAdviserEmail, setAssignedAdviserEmail] = useState("");
  const [isSavingAssignedAdviser, setIsSavingAssignedAdviser] = useState(false);
  const storage = getStorage();
  const [isSavingStaffNotes, setIsSavingStaffNotes] = useState(false);
    const { advisers, loadingAdvisers } = useAdviserListWithUnappointed();
  const adviserOptions = [
    {
      id: "",
      name: loadingAdvisers ? "Loading advisers..." : "Select Adviser",
    },
    ...advisers.map((adv) => ({
      id: adv.email,
      name: `${adv.email} ${adv.name ? `(${adv.name})` : ""}`,
    })),
  ];

  const buildFlagDecisionKey = (attemptId, flag, index = 0) => {
    const source = String(flag?.source || "")
      .trim()
      .toLowerCase();
    const type = String(flag?.type || "")
      .trim()
      .toLowerCase();
    const snippet = String(flag?.snippet || "")
      .trim()
      .toLowerCase();
    const id = String(flag?.id || `flag-${index}`)
      .trim()
      .toLowerCase();

    return `${attemptId || "attempt"}::${id}::${source}::${type}::${snippet}`;
  };

  const saveFlagRating = async (attempt, flag, rating, flagDecisionKey) => {
    if (!attempt?.ref || !flagDecisionKey) return;

    const now = new Date().toISOString();
    const saveKey = `${attempt.id}:${flagDecisionKey}`;

    setSavingFlagRatings((prev) => ({
      ...prev,
      [flagDecisionKey]: true,
      [saveKey]: true,
    }));

    try {
      const current =
        attempt?.flagRatings && typeof attempt.flagRatings === "object"
          ? attempt.flagRatings
          : {};

      const currentDecision = String(
        current?.[flagDecisionKey]?.rating || "",
      ).toLowerCase();

      const nextRating =
        currentDecision &&
        currentDecision === String(rating || "").toLowerCase()
          ? ""
          : String(rating || "").toLowerCase();

      const next = {
        ...current,
        [flagDecisionKey]: {
          rating: nextRating,
          reviewedAt: now,
          reviewedByEmail: nextRating ? reviewerEmail || "" : "",
          flagId: flag?.id || "",
          source: flag?.source || "",
          type: flag?.type || "",
          snippet: flag?.snippet || "",
          reason: flag?.reason || "",
          fix: flag?.fix || "",
        },
      };

      await setDoc(
        attempt.ref,
        {
          flagRatings: next,
          updatedAt: now,
        },
        { merge: true },
      );

      setFlagRatingsByAttemptId((prev) => ({
        ...prev,
        [attempt.id]: next,
      }));
    } catch (error) {
      // alert(error?.message || "Failed to save flag rating.");
    } finally {
      setSavingFlagRatings((prev) => ({
        ...prev,
        [flagDecisionKey]: false,
        [saveKey]: false,
      }));
    }
  };

  useEffect(() => {
    if (!attempts.length) {
      setFlagRatingsByAttemptId({});
      return;
    }

    const next = {};
    attempts.forEach((attempt) => {
      next[attempt.id] =
        attempt?.flagRatings && typeof attempt.flagRatings === "object"
          ? attempt.flagRatings
          : {};
    });

    setFlagRatingsByAttemptId(next);
  }, [attempts]);

  const postFpApi = async (endpoint, payload) => {
    if (!FP_API_BASE_URL) {
      throw new Error("REACT_APP_FINANCIAL_PROMOTIONS_API_URL is not set");
    }

    const response = await fetch(`${FP_API_BASE_URL}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
    });

    if (!response.ok) {
      const responseText = await response.text();
      throw new Error(responseText || `Request failed (${response.status})`);
    }

    return response;
  };

  const formatDecisionForBackend = (value) => {
    const normalized = String(value || "")
      .trim()
      .toLowerCase();
    if (!normalized) return "";

    return normalized
      .split("_")
      .map((part) =>
        part ? `${part.charAt(0).toUpperCase()}${part.slice(1)}` : "",
      )
      .join("_");
  };

  const { userEmail: currentUserEmail } = useUserEmail() || {};
  const {
    userEmail: routeUserEmailParam,
    submissionId: routeSubmissionIdParam,
  } = useParams();

  const reviewerEmail = String(
    currentUserEmail || localStorage.getItem("userEmail") || "",
  )
    .trim()
    .toLowerCase();
  
  const isRosemountEmail = (email) =>
    String(email || "")
      .trim()
      .toLowerCase()
      .endsWith("@rosemountfs.co.uk");

  const routeUserEmail = routeUserEmailParam
    ? decodeURIComponent(routeUserEmailParam)
    : "";
  const routeSubmissionId = routeSubmissionIdParam
    ? decodeURIComponent(routeSubmissionIdParam)
    : "";

useEffect(() => {
  setStaffInfoNotes(selectedSubmission?.staffInfoNotes || "");
}, [selectedSubmission?.staffInfoNotes]);

const saveStaffInfoNotes = async () => {
  if (!selectedSubmission?.ref) return;

  const now = new Date().toISOString();

  setIsSavingStaffNotes(true);

  try {
    await setDoc(
      selectedSubmission.ref,
      {
        staffInfoNotes,
        staffInfoNotesUpdatedAt: now,
        staffInfoNotesUpdatedBy: reviewerEmail || "",
        updatedAt: now,
      },
      { merge: true },
    );
  } finally {
    setIsSavingStaffNotes(false);
  }
  };

const saveAssignedAdviser = async () => {
  if (!selectedSubmission?.ref) return;

  const email = String(assignedAdviserEmail || "")
    .trim()
    .toLowerCase();

  if (!email) return;

  const selectedOption = advisers.find(
    (adviser) =>
      String(adviser.email || "")
        .trim()
        .toLowerCase() === email,
  );

  const adviserName =
    selectedOption?.name ||
    selectedOption?.tradingName ||
    selectedOption?.tradingStyle ;

  const now = new Date().toISOString();

  const adviserMeta = {
    email,
    name: adviserName,
    tradingName: selectedOption?.tradingName || adviserName,
    tradingStyle: selectedOption?.tradingStyle || adviserName,
    source: "staff_assignment",
  };

  setIsSavingAssignedAdviser(true);

  try {
    await setDoc(
      selectedSubmission.ref,
      {
        assignedAdviser: adviserMeta,
        assignedAdviserEmail: email,
        assignedAdviserName: adviserName,
        adviserName,
        adviserMeta,
        userDataMeta: adviserMeta,
        adviserAssignedAt: now,
        adviserAssignedBy: reviewerEmail || "",
        updatedAt: now,
      },
      { merge: true },
    );

    if (latestAttempt?.ref) {
      await setDoc(
        latestAttempt.ref,
        {
          input: {
            ...(latestAttempt?.input || {}),
            adviserMeta,
            userDataMeta: adviserMeta,
          },
          updatedAt: now,
        },
        { merge: true },
      );
    }
  } finally {
    setIsSavingAssignedAdviser(false);
  }
};
  
const downloadWithFileName = async (url, fileName) => {
  if (!url) return;

  const targetName = fileName || "attachment";

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`);
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = targetName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (downloadError) {
    //   console.error("Download with filename failed:", downloadError);
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

const openFileFromPath = async (storagePath, fileName) => {
  if (!storagePath) return;

  try {
    const fileRef = storageRef(storage, storagePath);
    const url = await getDownloadURL(fileRef);
    await downloadWithFileName(url, fileName);
  } catch (error) {
    //   console.error("Failed to open file:", error);
    // alert(
    //   "Could not open this file. Check Storage rules/permissions and path.",
    // );
  }
};

const openAttachment = async (attachment) => {
  if (!attachment) return;

  if (attachment.downloadURL) {
    await downloadWithFileName(attachment.downloadURL, attachment.name);
    return;
  }

  if (attachment.storagePath) {
    await openFileFromPath(attachment.storagePath, attachment.name);
  }
};

const handleCopyReference = async () => {
  try {
    await navigator.clipboard.writeText(String(selectedReference || ""));
    setIsReferenceCopied(true);
    setTimeout(() => setIsReferenceCopied(false), 1500);
  } catch {
    setIsReferenceCopied(false);
  }
};

useEffect(() => {
  if (!routeUserEmail || !routeSubmissionId) {
    setDetailsError("Missing user email or submission id.");
    return undefined;
  }

  setDetailsError("");

  const submissionRef = doc(
    dbFinancialPromotions,
    "Approvals",
    routeUserEmail,
    "Submissions",
    routeSubmissionId,
  );

  const unsub = onSnapshot(
    submissionRef,
    (snap) => {
      if (!snap.exists()) {
        setDetailsError("Submission not found for this id.");
        setSelectedSubmission(null);
        return;
      }

      setSelectedSubmission({
        id: snap.id,
        ref: submissionRef,
        userEmail: routeUserEmail,
        ...snap.data(),
      });
    },
    (error) => {
      setDetailsError(error?.message || "Failed to load submission details.");
    },
  );

  return () => unsub();
}, [routeSubmissionId, routeUserEmail]);

useEffect(() => {
  if (!selectedSubmission?.ref) {
    setAttempts([]);
    return undefined;
  }

  const attemptsCol = collection(selectedSubmission.ref, ATTEMPTS_SUBCOL);
  const attemptsQuery = query(
    attemptsCol,
    orderBy("createdAt", "desc"),
    limit(50),
  );

  const unsub = onSnapshot(
    attemptsQuery,
    async (snap) => {
      const toEpoch = (value) => {
        if (!value) return 0;
        if (typeof value?.toDate === "function") {
          return value.toDate().getTime();
        }
        if (typeof value?.seconds === "number") {
          return value.seconds * 1000;
        }
        const parsed = new Date(value).getTime();
        return Number.isNaN(parsed) ? 0 : parsed;
      };

      const rows = snap.docs.map((attemptDoc) => {
        const attemptData = attemptDoc.data() || {};
        return {
          id: attemptDoc.id,
          ref: attemptDoc.ref,
          ...attemptData,
          media: Array.isArray(attemptData.media) ? attemptData.media : [],
          filesMeta: Array.isArray(attemptData?.input?.filesMeta)
            ? attemptData.input.filesMeta
            : [],
        };
      });

      rows.sort((a, b) => {
        const aTime = Math.max(
          toEpoch(a?.updatedAt),
          toEpoch(a?.completedAt),
          toEpoch(a?.createdAt),
        );
        const bTime = Math.max(
          toEpoch(b?.updatedAt),
          toEpoch(b?.completedAt),
          toEpoch(b?.createdAt),
        );
        return bTime - aTime;
      });

      setAttempts(rows);
    },
    () => setAttempts([]),
  );

  return () => unsub();
}, [selectedSubmission]);
  
  // useEffect(() => {
  //   const advisersQuery = query(
  //     collectionGroup(dbFinancialPromotions, "Submissions"),
  //     orderBy("createdAt", "desc"),
  //     limit(500),
  //   );

  //   const unsubscribe = onSnapshot(
  //     advisersQuery,
  //     (snap) => {
  //       const adviserMap = new Map();

  //       snap.docs.forEach((submissionDoc) => {
  //         const ownerEmail = String(submissionDoc.ref.parent?.parent?.id || "")
  //           .trim()
  //           .toLowerCase();

  //         const data = submissionDoc.data() || {};
  //         const assignedAdviser = data?.assignedAdviser || {};

  //         const adviserEmail = String(
  //           assignedAdviser?.email ||
  //             data?.assignedAdviserEmail ||
  //             data?.createdByEmail ||
  //             ownerEmail ||
  //             "",
  //         )
  //           .trim()
  //           .toLowerCase();

  //         if (!adviserEmail || isRosemountEmail(adviserEmail)) return;

  //         const adviserName =
  //           assignedAdviser?.tradingName ||
  //           assignedAdviser?.tradingStyle ||
  //           assignedAdviser?.name ||
  //           data?.assignedAdviserName ||
  //           data?.adviserName ||
  //           data?.companyName ||
  //           data?.firmName;
  //           // ||
  //           // extractNameFromEmail(adviserEmail);

  //         if (!adviserMap.has(adviserEmail)) {
  //           adviserMap.set(adviserEmail, {
  //             email: adviserEmail,
  //             name: adviserName,
  //             tradingName: adviserName,
  //             tradingStyle: adviserName,
  //           });
  //         }
  //       });

  //       setAdviserOptions(
  //         Array.from(adviserMap.values()).sort((a, b) =>
  //           String(a.name || a.email).localeCompare(
  //             String(b.name || b.email),
  //             undefined,
  //             {
  //               sensitivity: "base",
  //             },
  //           ),
  //         ),
  //       );
  //     },
  //     () => {
  //       setAdviserOptions([]);
  //     },
  //   );

  //   return () => unsubscribe();
  // }, []);

useEffect(() => {
  if (!attempts.length) {
    setAiByAttemptId({});
    return;
  }

  const unsubs = attempts.map((attempt) => {
    const aiRef = doc(attempt.ref, "private", "ai");
    return onSnapshot(
      aiRef,
      (snap) => {
        setAiByAttemptId((prev) => ({
          ...prev,
          [attempt.id]: snap.exists() ? snap.data() : null,
        }));
      },
      () => {
        setAiByAttemptId((prev) => ({
          ...prev,
          [attempt.id]: null,
        }));
      },
    );
  });

  return () => unsubs.forEach((unsubscribe) => unsubscribe && unsubscribe());
}, [attempts]);

useEffect(() => {
  if (!attempts.length) {
    setExpandedAttemptsById({});
    return;
  }

  setExpandedAttemptsById((prev) => {
    const next = {};
    attempts.forEach((attempt, index) => {
      const expandKey = String(
        attempt?.id || `${attempt?.attemptNumber || "attempt"}-${index}`,
      );
      if (Object.prototype.hasOwnProperty.call(prev, expandKey)) {
        next[expandKey] = prev[expandKey];
      } else {
        next[expandKey] = index === 0;
      }
    });
    return next;
  });
}, [attempts]);
  
  const latestAttempt = attempts[0] || null;

  const isStaffOwnedSubmission = isRosemountEmail(
    selectedSubmission?.userEmail || routeUserEmail,
  );

  const assignedAdviserMeta = selectedSubmission?.assignedAdviser || {};

  const selectedAdviserMeta =
    assignedAdviserMeta?.email || selectedSubmission?.assignedAdviserEmail
      ? {
          ...assignedAdviserMeta,
          email:
            assignedAdviserMeta?.email ||
            selectedSubmission?.assignedAdviserEmail ||
            "",
          tradingName:
            assignedAdviserMeta?.tradingName ||
            assignedAdviserMeta?.name ||
            selectedSubmission?.assignedAdviserName ||
            "",
          tradingStyle:
            assignedAdviserMeta?.tradingStyle ||
            assignedAdviserMeta?.name ||
            selectedSubmission?.assignedAdviserName ||
            "",
          firstName: assignedAdviserMeta?.firstName || "",
          lastName: assignedAdviserMeta?.lastName || "",
        }
      : latestAttempt?.input?.adviserMeta || {};

  useEffect(() => {
    const existingEmail =
      selectedSubmission?.assignedAdviser?.email ||
      selectedSubmission?.assignedAdviserEmail ||
      latestAttempt?.input?.adviserMeta?.email ||
      "";

    setAssignedAdviserEmail(
      String(existingEmail || "")
        .trim()
        .toLowerCase(),
    );
  }, [
    latestAttempt?.input?.adviserMeta?.email,
    selectedSubmission?.assignedAdviser?.email,
    selectedSubmission?.assignedAdviserEmail,
  ]);
  


const selectedPrimaryLabel =
  selectedAdviserMeta?.tradingName ||
  selectedAdviserMeta?.tradingStyle ||
  [selectedAdviserMeta?.firstName, selectedAdviserMeta?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim() ||
  selectedSubmission?.title ||
  selectedSubmission?.companyName ||
  selectedSubmission?.firmName ||
  selectedSubmission?.adviserName ||
  "Adviser";

const selectedReference =
  selectedSubmission?.reference ||
  selectedSubmission?.submissionReference ||
  selectedSubmission?.id ||
  "-";

const selectedStatus =
  // selectedSubmission?.finalDecision ||
  selectedSubmission?.decision ||
  latestAttempt?.decision ||
  selectedSubmission?.status ||
  latestAttempt?.status ||
  "Unknown";

const normalizedOverallStatus = String(
  // selectedSubmission?.finalDecision ||
  selectedSubmission?.decision ||
    latestAttempt?.decision ||
    selectedSubmission?.status ||
    latestAttempt?.status ||
    "",
).toLowerCase();
const isOverallApproved = ["approved", "completed"].includes(
  normalizedOverallStatus,
);
const isOverallDeclined = ["declined", "rejected", "failed"].includes(
  normalizedOverallStatus,
);

const isOverallActionRequired =
  String(selectedSubmission?.status || "").toLowerCase() ===
    "action_required" ||
  String(selectedSubmission?.decision || "").toLowerCase() ===
    "action_required";
const isOverallReadOnly =
  isOverallActionRequired || isOverallApproved || isOverallDeclined;

const firstAttempt =
  attempts.find((attempt) => Number(attempt?.attemptNumber) === 1) ||
  attempts[attempts.length - 1] ||
  null;

const firstAttemptAiDoc = firstAttempt
  ? aiByAttemptId?.[firstAttempt.id]
  : null;
const firstAttemptAiResult = firstAttemptAiDoc?.result || null;
const firstAttemptAiAnalysis =
  firstAttemptAiResult?.analysis || firstAttemptAiDoc?.analysis || null;
const firstAttemptAiRisk =
  firstAttemptAiAnalysis?.risk ||
  firstAttemptAiResult?.risk ||
  firstAttemptAiDoc?.risk ||
  null;

const selectedRiskLabel = getRiskLabel(
  selectedSubmission,
  firstAttemptAiRisk,
  firstAttempt,
);

const selectedMediaTypes = Array.isArray(latestAttempt?.input?.mediaTypes)
  ? latestAttempt.input.mediaTypes.join(", ")
    : "";
  
  const createdByEmail =
    selectedSubmission?.createdByEmail ||
    latestAttempt?.input?.createdByEmail ||
    routeUserEmail ||
    "-";

  const submissionOwnerEmail =
    selectedSubmission?.userEmail || routeUserEmail || "-";

  const assignedAdviserDisplayEmail =
    selectedSubmission?.assignedAdviser?.email ||
    selectedSubmission?.assignedAdviserEmail ||
    selectedAdviserMeta?.email ||
    "-";

const selectedEmail = assignedAdviserDisplayEmail;

const latestApprovedAttempt =
  attempts.find((attempt) => {
    const decision = String(attempt?.decision || "")
      .trim()
      .toLowerCase();
    const reviewDecision = String(attempt?.review?.decision || "")
      .trim()
      .toLowerCase();
    const status = String(attempt?.status || "")
      .trim()
      .toLowerCase();
    return [decision, reviewDecision, status].includes("approved");
  }) || null;

const latestAttemptAiDoc = latestAttempt
  ? aiByAttemptId?.[latestAttempt.id]
  : null;
const latestAttemptAiResult = latestAttemptAiDoc?.result || null;
const latestAttemptAiReview =
  latestAttemptAiResult?.analysis || latestAttemptAiDoc?.analysis || null;

const latestApprovedAttemptAiDoc = latestApprovedAttempt
  ? aiByAttemptId?.[latestApprovedAttempt.id]
  : null;
const latestApprovedAttemptAiResult =
  latestApprovedAttemptAiDoc?.result || null;
const latestApprovedAttemptAiReview =
  latestApprovedAttemptAiResult?.analysis ||
  latestApprovedAttemptAiDoc?.analysis ||
  null;

const overviewApprovalConditions = (
  Array.isArray(latestApprovedAttempt?.approvalConditions)
    ? latestApprovedAttempt.approvalConditions
    : Array.isArray(latestApprovedAttempt?.review?.approvalConditions)
      ? latestApprovedAttempt.review.approvalConditions
      : Array.isArray(latestApprovedAttemptAiReview?.approvalConditions)
        ? latestApprovedAttemptAiReview.approvalConditions
        : Array.isArray(latestApprovedAttemptAiResult?.approvalConditions)
          ? latestApprovedAttemptAiResult.approvalConditions
          : Array.isArray(selectedSubmission?.approvalConditions)
            ? selectedSubmission.approvalConditions
            : []
)
  .map((condition) =>
    String(condition || "")
      .replace(/^\s*[•\-*]\s*/, "")
      .trim(),
  )
  .filter(Boolean);

const overviewNotes = String(
  latestApprovedAttempt?.staffReviewText ||
    latestApprovedAttempt?.staffReview ||
    latestApprovedAttemptAiReview?.staffReviewText ||
    latestApprovedAttemptAiReview?.staffReview ||
    latestApprovedAttemptAiResult?.staffReviewText ||
    latestApprovedAttemptAiResult?.staffReview ||
    "",
).trim();

const overviewApprovalDate = toJsDate(
  latestApprovedAttempt?.approvedAt ||
    latestApprovedAttempt?.reviewedAt ||
    latestApprovedAttempt?.updatedAt ||
    latestApprovedAttempt?.completedAt ||
    selectedSubmission?.approvedAt,
);

const overviewExpiryDate = toJsDate(selectedSubmission?.expiryDate) || (overviewApprovalDate
  ? (() => {
      const date = new Date(overviewApprovalDate);
      date.setFullYear(date.getFullYear() + 1);
      return date;
    })()
  : null);

const canReapprove = normalizedOverallStatus === "approved";
const handleReapprove = async () => {
  if (!canReapprove || !selectedSubmission?.ref || !reviewerEmail || isReapproving) return;
  setIsReapproving(true);
  setReapprovalMessage("");
  try {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    await updateDoc(selectedSubmission.ref, {
      expiryDate,
      approvedByEmail: reviewerEmail,
    });
    setReapprovalMessage("Re-approved. Expiry date and approver updated.");
  } catch (error) {
    // console.error("Failed to re-approve submission:", error);
    // setReapprovalMessage("Unable to re-approve. Please try again.");
  } finally {
    setIsReapproving(false);
  }
};

const overallReviewerEmail =
  (selectedSubmission?.expiryDate && selectedSubmission?.approvedByEmail) ||
  selectedSubmission?.reviewedByEmail ||
  selectedSubmission?.approvedByEmail ||
  selectedSubmission?.requestedByEmail ||
  selectedSubmission?.declinedByEmail ||
  latestApprovedAttempt?.reviewedByEmail ||
  latestApprovedAttempt?.approvedByEmail ||
  latestApprovedAttempt?.requestedByEmail ||
  latestApprovedAttempt?.declinedByEmail ||
  latestAttempt?.reviewedByEmail ||
  latestAttempt?.approvedByEmail ||
  latestAttempt?.requestedByEmail ||
  latestAttempt?.declinedByEmail ||
  latestApprovedAttemptAiReview?.reviewedByEmail ||
  latestApprovedAttemptAiReview?.approvedByEmail ||
  latestApprovedAttemptAiReview?.requestedByEmail ||
  latestApprovedAttemptAiReview?.declinedByEmail ||
  latestApprovedAttemptAiResult?.reviewedByEmail ||
  latestApprovedAttemptAiResult?.approvedByEmail ||
  latestApprovedAttemptAiResult?.requestedByEmail ||
  latestApprovedAttemptAiResult?.declinedByEmail ||
  selectedSubmission?.createdByEmail ||
  "";

 const getAttemptSubmittedDate = (attempt, submission) => {
   return (
     toJsDate(attempt?.createdAt) ||
     toJsDate(attempt?.submittedAt) ||
     toJsDate(submission?.createdAt) ||
     null
   );
 };

const WORK_START_HOUR = 8.5;
const WORK_END_HOUR = 17;
const WORKING_DAY_MS = (WORK_END_HOUR - WORK_START_HOUR) * 60 * 60 * 1000;

const setTimeFromDecimalHour = (date, decimalHour) => {
  const next = new Date(date);
  const hours = Math.floor(decimalHour);
  const minutes = Math.round((decimalHour - hours) * 60);

  next.setHours(hours, minutes, 0, 0);
  return next;
};

const isWorkingDay = (date) => {
  const day = date.getDay();
  return day !== 0 && day !== 6; // excludes Sunday and Saturday
};

const getWorkingDurationMs = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  if (endDate <= startDate) return 0;

  let totalMs = 0;
  const cursor = new Date(startDate);

  while (cursor < endDate) {
    if (isWorkingDay(cursor)) {
      const workStart = setTimeFromDecimalHour(cursor, WORK_START_HOUR);
      const workEnd = setTimeFromDecimalHour(cursor, WORK_END_HOUR);

      const rangeStart = new Date(
        Math.max(cursor.getTime(), workStart.getTime()),
      );
      const rangeEnd = new Date(Math.min(endDate.getTime(), workEnd.getTime()));

      if (rangeEnd > rangeStart) {
        totalMs += rangeEnd.getTime() - rangeStart.getTime();
      }
    }

    cursor.setDate(cursor.getDate() + 1);
    cursor.setHours(0, 0, 0, 0);
  }

  return totalMs;
};

const formatResponseDuration = (milliseconds) => {
  if (!milliseconds || milliseconds <= 0) return "-";

  const minutes = Math.round(milliseconds / 60000);
  const hours = milliseconds / 3600000;
  const workingDays = milliseconds / WORKING_DAY_MS;

  if (minutes < 60) return `${minutes} min`;

  if (hours < 8.5) {
    const roundedHours = Math.round(hours * 10) / 10;
    return `${roundedHours} hr`;
  }

  const roundedDays = Math.round(workingDays * 10) / 10;
  return `${roundedDays} working day${roundedDays === 1 ? "" : "s"}`;
};

const buildFirstStaffResponseFields = ({
  attempt,
  submission,
  reviewerEmail,
  now,
}) => {
  if (!reviewerEmail) return {};

  // Do not overwrite once saved.
  if (attempt?.firstStaffResponseAt) return {};

  const submittedDate = getAttemptSubmittedDate(attempt, submission);
  const responseDate = new Date(now);

  if (!submittedDate || Number.isNaN(responseDate.getTime())) return {};

  const durationMs = getWorkingDurationMs(submittedDate, responseDate);

  if (durationMs <= 0) return {};

  return {
    firstStaffResponseAt: now,
    firstStaffResponseBy: reviewerEmail,
    staffResponseStartedAt: submittedDate.toISOString(),

    // This is now working-hours only.
    staffResponseDurationMs: durationMs,
    staffResponseDurationLabel: formatResponseDuration(durationMs),
  };
};

  const saveAttemptReview = async (attempt, payload) => {
    if (!attempt?.ref || !selectedSubmission?.ref) return;

    const normalizedDecision = String(payload?.decision || "")
      .trim()
      .toLowerCase();

    const submissionStatus =
      normalizedDecision === "approved"
        ? "completed"
        : normalizedDecision === "declined"
          ? "failed"
          : "action_required";

    const now = new Date().toISOString();

    const approvalConditions = Array.isArray(payload?.approvalConditions)
      ? payload.approvalConditions
      : [];

    const staffReviewText = String(payload?.staffReviewText || "");

    const firstStaffResponseFields = buildFirstStaffResponseFields({
      attempt,
      submission: selectedSubmission,
      reviewerEmail,
      now,
    });

    const reviewerFields = reviewerEmail
      ? {
          reviewedByEmail: reviewerEmail,
          reviewedAt: now,

          ...(normalizedDecision === "approved"
            ? {
                approvedByEmail: reviewerEmail,
                approvedAt: now,
              }
            : {}),

          ...(normalizedDecision === "requested_changes"
            ? {
                requestedByEmail: reviewerEmail,
                requestedAt: now,
              }
            : {}),

          ...(normalizedDecision === "declined"
            ? {
                declinedByEmail: reviewerEmail,
                declinedAt: now,
              }
            : {}),
        }
      : {};
    
const assignedOrSubmittedAdviserEmail =
  selectedSubmission?.assignedAdviser?.email ||
  selectedSubmission?.assignedAdviserEmail ||
  selectedSubmission?.adviserMeta?.email ||
  latestAttempt?.input?.adviserMeta?.email ||
  latestAttempt?.input?.userDataMeta?.email ||
  selectedSubmission?.createdByEmail ||
  selectedSubmission?.userEmail ||
  routeUserEmail ||
  "";

    setSavingByAttemptId((prev) => ({
      ...prev,
      [attempt.id]: true,
    }));

    try {
      await setDoc(
        attempt.ref,
        {
          decision: normalizedDecision || attempt?.decision || "processing",
          status: submissionStatus,
          staffReviewText,
          staffReview: staffReviewText,
          approvalConditions,
          updatedAt: now,
          ...reviewerFields,
          ...firstStaffResponseFields,
        },
        { merge: true },
      );

      const aiReviewRef = doc(attempt.ref, "private", "review");

      await setDoc(
        aiReviewRef,
        {
          decision: normalizedDecision || attempt?.decision || "processing",
          staffReviewText,
          approvalConditions,
          updatedAt: now,
          ...reviewerFields,
          ...firstStaffResponseFields,
        },
        { merge: true },
      );

   await setDoc(
     selectedSubmission.ref,
     {
       status: submissionStatus,
       decision: normalizedDecision || attempt?.decision || "processing",
       updatedAt: now,

       latestStaffResponseAt: now,
       latestStaffResponseBy: reviewerEmail || "",

       ...(selectedAdviserMeta?.email
         ? {
             assignedAdviser: selectedAdviserMeta,
             assignedAdviserEmail: selectedAdviserMeta.email,
             assignedAdviserName:
               selectedAdviserMeta.name ||
               selectedAdviserMeta.tradingName ||
               selectedAdviserMeta.tradingStyle,
             adviserMeta: selectedAdviserMeta,
             userDataMeta: selectedAdviserMeta,
           }
         : {}),

       ...reviewerFields,
     },
     { merge: true },
   );
      if (submissionStatus === "action_required") {
        const submissionOwnerEmail =
          selectedSubmission?.userEmail || routeUserEmail || "";

        const adviserEmail = assignedOrSubmittedAdviserEmail;

        await postFpApi(FP_REVIEW_ENDPOINT, {
          userEmail: submissionOwnerEmail,
          submissionId: selectedSubmission?.id || routeSubmissionId || "",
          attemptId: attempt?.id || "",
          decision: formatDecisionForBackend("requested_changes"),
          staffReviewText,
          approvalConditions,
          reviewedByEmail: reviewerEmail,
          adviserEmail,
        });
      }

      if (["approved", "declined"].includes(normalizedDecision)) {
        const submissionOwnerEmail =
          selectedSubmission?.userEmail || routeUserEmail || "";

        const adviserEmail = assignedOrSubmittedAdviserEmail;
        const decisionTitle =
          String(attempt?.input?.title || "").trim() ||
          String(selectedSubmission?.title || "").trim();

        await postFpApi(FP_DECISION_EMAIL_ENDPOINT, {
          submissionId: selectedSubmission?.id || routeSubmissionId || "",
          userEmail: submissionOwnerEmail,
          decision: formatDecisionForBackend(normalizedDecision),
          adviserEmail,
          title: decisionTitle,
        });
      }
    } catch (error) {
      console.error("Failed to save review:", error);
    } finally {
      setSavingByAttemptId((prev) => ({
        ...prev,
        [attempt.id]: false,
      }));
    }
  };
  
const getAttachmentDecisionKey = (attachment) =>
  String(
    attachment?.storagePath ||
      attachment?.downloadURL ||
      attachment?.name ||
      "attachment",
  )
    .trim()
    .toLowerCase();

const getAttemptReviewState = (attempt) => {
  const attemptMedia = Array.isArray(attempt?.media) ? attempt.media : [];
  const attemptFilesMeta = Array.isArray(attempt?.filesMeta)
    ? attempt.filesMeta
    : [];
  const attemptAttachments = buildAttachments(attemptMedia, attemptFilesMeta);

  const areAllAttachmentsReviewed = attemptAttachments.every((attachment) => {
    const decisionKey = getAttachmentDecisionKey(attachment);
    const decisionValue = String(
      attempt?.fileReviewDecisions?.[decisionKey]?.decision || "",
    )
      .trim()
      .toLowerCase();
    return decisionValue === "approved" || decisionValue === "declined";
  });

  const areAllAttachmentsApproved = attemptAttachments.every((attachment) => {
    const decisionKey = getAttachmentDecisionKey(attachment);
    const decisionValue = String(
      attempt?.fileReviewDecisions?.[decisionKey]?.decision || "",
    )
      .trim()
      .toLowerCase();
    return decisionValue === "approved";
  });

  const hasContent = Boolean(
    String(attempt?.input?.text || "").trim() ||
    String(attempt?.input?.url || "").trim(),
  );
  const contentDecisionValue = String(
    attempt?.contentReviewDecision?.decision || "",
  )
    .trim()
    .toLowerCase();

  const isContentReviewed =
    !hasContent ||
    contentDecisionValue === "approved" ||
    contentDecisionValue === "declined";
  const isContentApproved = !hasContent || contentDecisionValue === "approved";

  return {
    isReviewed: areAllAttachmentsReviewed && isContentReviewed,
    isApproved: areAllAttachmentsApproved && isContentApproved,
  };
};

const saveAttachmentDecision = async (attempt, attachment, decision) => {
  if (!attempt?.ref || !attachment) return;

  const key = getAttachmentDecisionKey(attachment);
  const saveKey = `${attempt.id}:${key}`;
  const now = new Date().toISOString();
  const normalizedIncomingDecision = String(decision || "")
    .trim()
    .toLowerCase();
  const currentDecision = String(
    attempt?.fileReviewDecisions?.[key]?.decision || "",
  )
    .trim()
    .toLowerCase();
  const nextDecision =
    currentDecision && currentDecision === normalizedIncomingDecision
      ? ""
      : normalizedIncomingDecision;
  const current =
    attempt?.fileReviewDecisions &&
    typeof attempt.fileReviewDecisions === "object"
      ? attempt.fileReviewDecisions
      : {};

  const next = {
    ...current,
    [key]: {
      decision: nextDecision,
      reviewedAt: now,
      reviewedByEmail: nextDecision ? reviewerEmail || "" : "",
      fileName: attachment?.name || "",
      storagePath: attachment?.storagePath || "",
      downloadURL: attachment?.downloadURL || "",
    },
  };

  setSavingFileDecisions((prev) => ({ ...prev, [saveKey]: true }));

  try {
    await setDoc(
      attempt.ref,
      {
        fileReviewDecisions: next,
        updatedAt: now,
      },
      { merge: true },
    );
  } catch (error) {
    // alert(
    //   error?.message || "Failed to save file decision. Please try again.",
    // );
  } finally {
    setSavingFileDecisions((prev) => ({ ...prev, [saveKey]: false }));
  }
};

const saveContentDecision = async (attempt, decision) => {
  if (!attempt?.ref) return;

  const now = new Date().toISOString();
  const normalizedIncomingDecision = String(decision || "")
    .trim()
    .toLowerCase();
  const currentDecision = String(attempt?.contentReviewDecision?.decision || "")
    .trim()
    .toLowerCase();
  const nextDecision =
    currentDecision && currentDecision === normalizedIncomingDecision
      ? ""
      : normalizedIncomingDecision;
  setSavingContentDecisions((prev) => ({ ...prev, [attempt.id]: true }));

  try {
    await setDoc(
      attempt.ref,
      {
        contentReviewDecision: {
          decision: nextDecision,
          reviewedAt: now,
          reviewedByEmail: nextDecision ? reviewerEmail || "" : "",
          text: String(attempt?.input?.text || ""),
          url: String(attempt?.input?.url || "").trim(),
        },
        updatedAt: now,
      },
      { merge: true },
    );
  } catch (error) {
    // alert(
    //   error?.message || "Failed to save content decision. Please try again.",
    // );
  } finally {
    setSavingContentDecisions((prev) => ({ ...prev, [attempt.id]: false }));
  }
};

const allMediaItemsReviewed = attempts.every(
  (attempt) => getAttemptReviewState(attempt).isReviewed,
);

const shouldShowApprovalConditions =
  isOverallApproved && overviewApprovalConditions.length > 0;

const shouldShowOverviewNotes = isOverallApproved && Boolean(overviewNotes);

const approvedMediaAcrossAttempts = attempts.flatMap((attempt, index) => {
  const media = Array.isArray(attempt?.media) ? attempt.media : [];
  const filesMeta = Array.isArray(attempt?.filesMeta) ? attempt.filesMeta : [];
  const attachments = buildAttachments(media, filesMeta);
  const parsedAttemptNumber = Number(attempt?.attemptNumber);
  const displayAttemptNumber =
    Number.isFinite(parsedAttemptNumber) && parsedAttemptNumber > 0
      ? parsedAttemptNumber
      : attempts.length - index;
  const attemptLabel = attempt?.reuploadOfAttemptId
    ? `Re-upload Attempt ${displayAttemptNumber}`
    : `Original Submission (Attempt ${displayAttemptNumber})`;

  return attachments
    .map((attachment) => {
      const decisionKey = getAttachmentDecisionKey(attachment);
      const decisionValue = String(
        attempt?.fileReviewDecisions?.[decisionKey]?.decision || "",
      )
        .trim()
        .toLowerCase();

      return {
        attemptId: attempt.id,
        attemptLabel,
        attachment,
        decisionValue,
      };
    })
    .filter((item) => item.decisionValue === "approved");
});

const approvedContentAcrossAttempts = attempts
  .map((attempt, index) => {
    const decisionValue = String(attempt?.contentReviewDecision?.decision || "")
      .trim()
      .toLowerCase();
    if (decisionValue !== "approved") return null;

    const text = String(attempt?.input?.text || "").trim();
    const url = String(attempt?.input?.url || "").trim();
    if (!text && !url) return null;

    const parsedAttemptNumber = Number(attempt?.attemptNumber);
    const displayAttemptNumber =
      Number.isFinite(parsedAttemptNumber) && parsedAttemptNumber > 0
        ? parsedAttemptNumber
        : attempts.length - index;
    const attemptLabel = attempt?.reuploadOfAttemptId
      ? `Re-upload Attempt ${displayAttemptNumber}`
      : `Original Submission (Attempt ${displayAttemptNumber})`;

    return {
      attemptId: attempt.id,
      attemptLabel,
      text,
      url,
      urlHref: url ? (/^https?:\/\//i.test(url) ? url : `https://${url}`) : "",
    };
  })
  .filter(Boolean);

return (
  <div className="fp-admin-layout">
    <Breadcrumb
      items={[
        {
          label: "Compliance",
          to: "/Department/Compliance",
        },
        {
          label: "Financial Promotions",
          to: "/FinancialPromotions",
        },
        { label: "Promotion Details" },
      ]}
    />
    <div className="fp-header">
      <div className="fp-header-left">
        <div className="FP_H3">Promotion Details</div>
      </div>
      <StatusTag status={statusToChip(selectedStatus).label} />
    </div>
    {/* 
      <div className="fp-admin-details-head">
        {selectedSubmission && (
          <div className="fp-admin-details-meta">
            <div className="FP_Content_Semibold">{selectedPrimaryLabel}</div>
            <div className="FP_Content">
              Reference: #{String(selectedReference)}
            </div>
            <div
              className="FP_Content_Semibold"
              style={{
                color: getStatusColor(selectedStatus),
                border: `1px solid ${getStatusColor(selectedStatus)}`,
                borderRadius: 8,
                padding: "2px 10px",
              }}
            >
              {selectedStatus}
            </div>
            <RiskPill risk={selectedRiskLabel} />
          </div>
        )}
      </div> */}

    <div className="fp-admin-details-body">
      {detailsError ? (
        <div className="admin-review-card FP_Content">{detailsError}</div>
      ) : !selectedSubmission ? (
        <div className="admin-review-card FP_Content">
          Loading submission details...
        </div>
      ) : (
        <>
          <div className="admin-review-card">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 16, marginBottom: 0, padding: "0 0" }}>
              <div className="FP_Subtitle">Overview</div>
              {canReapprove && (
                <button
                  type="button"
                  className="fp-confirm-submit FP_Content"
                  style={{ padding: "10px 20px" }}
                  onClick={handleReapprove}
                  disabled={isReapproving || !reviewerEmail}
                >
                  {isReapproving ? "Re-approving..." : "Re-approve"}
                </button>
              )}
            </div>
            {reapprovalMessage && <div role="status" className="FP_Content" style={{ marginBottom: 16 }}>{reapprovalMessage}</div>}
            <div className="FP_Content_Semibold">{selectedPrimaryLabel}</div>
            <div className="FP_Content">{selectedEmail}</div>

            {/* <div className="fp-header-dates" style={{ marginTop: 10 }}>
              <div>
                <div className="FP_Content">Assigned Adviser</div>
                <div className="FP_Content">{assignedAdviserDisplayEmail}</div>
              </div>

              <div>
                <div className="FP_Content">Created By</div>
                <div className="FP_Content">{createdByEmail}</div>
              </div>

              <div>
                <div className="FP_Content">Submission Owner</div>
                <div className="FP_Content">{submissionOwnerEmail}</div>
              </div>
            </div> */}

            {isStaffOwnedSubmission && (
              <div className="fp-staff-info-notes">
                <div className="FP_Content_Semibold">Assigned Adviser</div>

                <CustomSelect
                  options={adviserOptions}
                  value={assignedAdviserEmail}
                  onChange={(event) =>
                    setAssignedAdviserEmail(event.target.value)
                  }
                  disabled={
                    !selectedSubmission?.ref ||
                    loadingAdvisers ||
                    isSavingAssignedAdviser
                  }
                  placeholder={
                    loadingAdvisers ? "Loading advisers..." : "Select Adviser"
                  }
                  style={{ marginBottom: 12 }}
                />

                <div className="fp-staff-info-actions">
                  <button
                    type="button"
                    className="fp-confirm-submit FP_Content"
                    onClick={saveAssignedAdviser}
                    disabled={
                      !selectedSubmission?.ref ||
                      !assignedAdviserEmail.trim() ||
                      loadingAdvisers ||
                      isSavingAssignedAdviser
                    }
                  >
                    {isSavingAssignedAdviser ? "Saving..." : "Save Adviser"}
                  </button>
                </div>

                {selectedSubmission?.adviserAssignedBy && (
                  <div className="FP_Help_Text">
                    Last assigned by {selectedSubmission.adviserAssignedBy}
                  </div>
                )}
              </div>
            )}

            {/* <RiskPill risk={selectedRiskLabel} /> */}
            <div className="FP_Content">{selectedMediaTypes}</div>
            <div className="FP_Body_Semibold">
              {selectedSubmission?.title || ""}
            </div>
            <div className="fp-header-dates">
              <div>
                <div className="FP_Content">Reference</div>
                <div
                  className="FP_Content"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <span>{selectedReference}</span>
                  <button
                    type="button"
                    className={`fp-ai-rewrite-copy-btn ${isReferenceCopied ? "is-copied" : ""}`}
                    onClick={handleCopyReference}
                    aria-label="Copy reference"
                    title={isReferenceCopied ? "Copied" : "Copy reference"}
                  >
                    <span>{isReferenceCopied ? "Copied" : "Copy"}</span>
                  </button>
                </div>
              </div>
              <div>
                <div className="FP_Content">Submitted</div>
                <div className="FP_Content">
                  {formatSubmittedDateTime(selectedSubmission?.createdAt)}
                </div>
              </div>
              <div>
                <div className="FP_Content">Created By</div>
                <div className="FP_Content">{createdByEmail}</div>
              </div>
              {normalizedOverallStatus === "requested_changes" &&
                selectedSubmission?.requestedByEmail && (
                  <div>
                    <div className="FP_Content">Changes Requested By</div>
                    <div className="FP_Content">
                      {selectedSubmission.requestedByEmail}
                    </div>
                  </div>
                )}
              {isOverallApproved && overviewApprovalDate && (
                <div>
                  <div className="FP_Content">Approved</div>
                  <div className="FP_Content">
                    {formatSubmittedDate(overviewApprovalDate)}
                  </div>
                </div>
              )}
              {isOverallApproved && overviewExpiryDate && (
                <div>
                  <div className="FP_Content">Expiry Date</div>
                  <div className="FP_Content">
                    {formatSubmittedDate(overviewExpiryDate)}
                  </div>
                </div>
              )}
              {(isOverallApproved || isOverallDeclined) &&
                overallReviewerEmail && (
                  <div>
                    <div className="FP_Content">
                      {isOverallApproved ? "Approved By" : "Declined By"}
                    </div>
                    <div className="FP_Content">{overallReviewerEmail}</div>
                  </div>
                )}
            </div>

            {(shouldShowApprovalConditions || shouldShowOverviewNotes) && (
              <div>
                {shouldShowApprovalConditions && (
                  <>
                    <div className="FP_Content_Semibold">
                      Approval Conditions
                    </div>
                    <ul
                      className="FP_Content"
                      style={{ margin: "6px 0 0", paddingLeft: 18 }}
                    >
                      {overviewApprovalConditions.map(
                        (condition, conditionIndex) => (
                          <li key={`overview-approval-${conditionIndex}`}>
                            {condition}
                          </li>
                        ),
                      )}
                    </ul>
                  </>
                )}

                {/* {shouldShowOverviewNotes && (
                    <>
                      <div
                        className="FP_Content_Semibold"
                        style={{
                          marginTop: shouldShowApprovalConditions ? 10 : 0,
                        }}
                      >
                        Notes
                      </div>
                      <div
                        className="FP_Content"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {overviewNotes}
                      </div>
                    </>
                  )} */}
              </div>
            )}

            <div className="FP_Content_Semibold">Please Note:</div>
            <div className="FP_Content">
              This financial promotion has been checked for regulatory
              compliance, we cannot guarantee accuracy of spelling and/or
              punctuation.
            </div>

            <div className="fp-staff-info-notes">
              <div className="FP_Content_Semibold">Internal Notes</div>

              <textarea
                className="fp-ai-feedback-input FP_Content"
                rows={4}
                placeholder="Enter internal notes for staff only..."
                value={staffInfoNotes}
                onChange={(e) => setStaffInfoNotes(e.target.value)}
                disabled={!selectedSubmission?.ref}
              />
              <div className="fp-staff-info-actions">
                <button
                  type="button"
                  className="fp-confirm-submit FP_Content"
                  onClick={saveStaffInfoNotes}
                  disabled={!selectedSubmission?.ref || isSavingStaffNotes}
                >
                  {isSavingStaffNotes ? "Saving..." : "Save Notes"}
                </button>
              </div>

              {selectedSubmission?.staffInfoNotesUpdatedBy && (
                <div className="FP_Help_Text">
                  Last updated by {selectedSubmission.staffInfoNotesUpdatedBy}
                </div>
              )}
            </div>
            <div>
              {/* <RiskPill
                  risk={selectedRiskLabel}
                  className="fp-risk-pill--small"
                /> */}
            </div>
          </div>

          <div className="admin-review-card">
            <div className="FP_Subtitle">Approved Media Across Attempts</div>
            {approvedMediaAcrossAttempts.length === 0 &&
            approvedContentAcrossAttempts.length === 0 ? (
              <div className="FP_Content">No approved media yet.</div>
            ) : (
              <div className="fp-admin-files-list">
                {approvedMediaAcrossAttempts.map((item, itemIndex) => {
                  const canOpen = Boolean(
                    item?.attachment?.downloadURL ||
                    item?.attachment?.storagePath,
                  );

                  return (
                    <div
                      key={`approved-media-${item.attemptId}-${itemIndex}`}
                      className="fp-admin-file-row"
                    >
                      <div
                        className="FP_Content"
                        style={{ flex: 1, minWidth: 220 }}
                      >
                        <span className="FP_Content_Semibold">
                          {item.attachment.name}
                        </span>
                        <span> - {item.attemptLabel}</span>
                      </div>
                      <button
                        type="button"
                        className="fp-admin-file-link FP_Content"
                        disabled={!canOpen}
                        onClick={() =>
                          canOpen ? openAttachment(item.attachment) : null
                        }
                      >
                        Open
                      </button>
                    </div>
                  );
                })}

                {approvedContentAcrossAttempts.map((item) => (
                  <div
                    key={`approved-content-${item.attemptId}`}
                    className="fp-admin-file-row"
                    style={{ alignItems: "flex-start" }}
                  >
                    <div
                      className="FP_Content"
                      style={{ flex: 1, minWidth: 220 }}
                    >
                      <div className="FP_Content_Semibold">
                        Content - {item.attemptLabel}
                      </div>
                      <div className="fp-attempt-content-panel">
                        {item.text ? (
                          <div className="fp-attempt-content">{item.text}</div>
                        ) : null}
                        {item.url ? (
                          <div className="fp-attempt-url">
                            <span className="FP_Content_Semibold">URL: </span>
                            <a
                              className="fp-attempt-url-link"
                              href={item.urlHref}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.url}
                            </a>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {attempts.length === 0 ? (
            <div className="admin-review-card FP_Content">
              No attempt details found for this submission.
            </div>
          ) : (
            attempts.map((attempt, index) => {
              const isLatestAttemptEditable = index === 0 && !isOverallReadOnly;
              const isMediaDecisionEditable = true;
              const aiDoc = aiByAttemptId?.[attempt.id] || null;
              const aiResult = aiDoc?.result || null;
              const aiReview = aiResult?.analysis || aiDoc?.analysis || null;
              const media = Array.isArray(attempt?.media) ? attempt.media : [];
              const filesMeta = Array.isArray(attempt?.filesMeta)
                ? attempt.filesMeta
                : [];
              const attachments = buildAttachments(media, filesMeta);

              const reuploadOfAttemptId = attempt?.reuploadOfAttemptId || "";
              const messageText = attempt?.input?.notes || "";
              const textContent = attempt?.input?.text || "";
              const submittedUrl = String(attempt?.input?.url || "").trim();
              const submittedUrlHref = submittedUrl
                ? /^https?:\/\//i.test(submittedUrl)
                  ? submittedUrl
                  : `https://${submittedUrl}`
                : "";
              const parsedAttemptNumber = Number(attempt?.attemptNumber);
              const displayAttemptNumber =
                Number.isFinite(parsedAttemptNumber) && parsedAttemptNumber > 0
                  ? parsedAttemptNumber
                  : attempts.length - index;
              const contentDecisionValue = String(
                attempt?.contentReviewDecision?.decision || "",
              )
                .trim()
                .toLowerCase();
              const contentDecisionReviewerEmail = String(
                attempt?.contentReviewDecision?.reviewedByEmail || "",
              )
                .trim()
                .toLowerCase();
              const contentDecisionLabel =
                contentDecisionValue === "approved"
                  ? "Passed"
                  : contentDecisionValue === "declined"
                    ? "Failed"
                    : "";
              const isSavingContentDecision = Boolean(
                savingContentDecisions?.[attempt.id],
              );
              const attemptReviewState = getAttemptReviewState(attempt);
              const attemptExpandKey = String(
                attempt?.id ||
                  `${attempt?.attemptNumber || "attempt"}-${index}`,
              );
              const isAttemptExpanded = Boolean(
                expandedAttemptsById?.[attemptExpandKey],
              );

              return (
                <div key={attempt.id} className="admin-attempt-card">
                  <div className="fp-admin-attempt-head">
                    <div className="FP_Subtitle_Semibold">
                      {!reuploadOfAttemptId
                        ? `Original Submission (Attempt ${displayAttemptNumber})`
                        : `Re-upload Attempt ${displayAttemptNumber}`}
                    </div>
                    <div className="fp-admin-attempt-head-right">
                      <div className="FP_Content">
                        {formatDateTime(
                          attempt?.updatedAt ||
                            attempt?.completedAt ||
                            attempt?.createdAt,
                        )}
                      </div>
                      <button
                        type="button"
                        className={`fp-attempt-toggle ${isAttemptExpanded ? "is-expanded" : ""}`}
                        aria-label={
                          isAttemptExpanded
                            ? "Collapse attempt"
                            : "Expand attempt"
                        }
                        aria-expanded={isAttemptExpanded}
                        onClick={() =>
                          setExpandedAttemptsById((prev) => ({
                            ...prev,
                            [attemptExpandKey]: !isAttemptExpanded,
                          }))
                        }
                      >
                        <ExpandIcon
                          className="fp-attempt-toggle-icon"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>

                  {isAttemptExpanded && (
                    <>
                      <div className="fp-content-review-card fp-admin-file-group">
                        <div className="fp-admin-file-row">
                          <div className="FP_Content">
                            <span className="FP_Content_Semibold">Message</span>
                          </div>
                        </div>

                        <div className="fp-attempt-content-panel">
                          <div className="fp-attempt-content FP_Content">
                            {messageText || "No message provided."}
                          </div>
                        </div>
                      </div>

                      <div className="fp-content-review-card fp-admin-file-group">
                        <div className="fp-admin-file-row">
                          <div className="FP_Content">
                            <span className="FP_Content_Semibold">Content</span>
                          </div>
                          <div className="fp-admin-decision-stack">
                            <div className="fp-admin-file-actions">
                              <PassedStatusOption
                                selected={contentDecisionValue === "approved"}
                                disabled={isSavingContentDecision}
                                onClick={() =>
                                  saveContentDecision(attempt, "approved")
                                }
                              />
                              <FailedStatusOption
                                selected={contentDecisionValue === "declined"}
                                disabled={isSavingContentDecision}
                                onClick={() =>
                                  saveContentDecision(attempt, "declined")
                                }
                              />
                            </div>
                            {contentDecisionLabel &&
                              contentDecisionReviewerEmail && (
                                <div className="FP_Content fp-admin-decision-meta FP_Help_Text">
                                  {`Marked by ${contentDecisionReviewerEmail}`}
                                </div>
                              )}
                          </div>
                        </div>
                        <div className="fp-attempt-content-panel">
                          <div className="fp-attempt-content FP_Content">
                            {textContent || "No content available."}
                          </div>
                          {submittedUrl && (
                            <div className="FP_Content fp-attempt-url">
                              <span className="FP_Content_Semibold">URL: </span>
                              <a
                                className="fp-attempt-url-link"
                                href={submittedUrlHref}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {submittedUrl}
                              </a>
                            </div>
                          )}
                        </div>
                      </div>

                      <MediaReviewCard
                        hasAiAnalysis={Boolean(aiReview)}
                        showFlags={false}
                        attachments={attachments}
                        attemptId={attempt.id}
                        fileReviewDecisions={attempt?.fileReviewDecisions || {}}
                        savingFileDecisions={savingFileDecisions}
                        flagRatings={flagRatingsByAttemptId?.[attempt.id] || {}}
                        savingFlagRatings={savingFlagRatings}
                        buildFlagDecisionKey={buildFlagDecisionKey}
                        onSaveFlagRating={(flag, rating, flagDecisionKey) =>
                          saveFlagRating(attempt, flag, rating, flagDecisionKey)
                        }
                        isMediaDecisionEditable={isMediaDecisionEditable}
                        getAttachmentDecisionKey={getAttachmentDecisionKey}
                        onOpenAttachment={openAttachment}
                        onSaveAttachmentDecision={(attachment, decision) =>
                          saveAttachmentDecision(attempt, attachment, decision)
                        }
                        showRequestChanges={!attemptReviewState.isApproved}
                        showDecisionAndFeedback={!attemptReviewState.isApproved}
                        isReadOnly={isOverallReadOnly}
                        showApprovalConditions={attemptReviewState.isReviewed}
                        isApprovalEditable={isLatestAttemptEditable}
                        isStaffReviewEditable={isLatestAttemptEditable}
                        isFinalDecisionEditable={isLatestAttemptEditable}
                        isSaving={Boolean(savingByAttemptId?.[attempt.id])}
                        onSaveReview={(payload) =>
                          saveAttemptReview(attempt, payload)
                        }
                        review={{
                          ...(aiReview || {}),
                          risk:
                            aiReview?.risk ||
                            aiResult?.risk ||
                            attempt?.riskDetected ||
                            "UNKNOWN",
                          decision:
                            aiReview?.decision ||
                            aiResult?.decision ||
                            attempt?.decision ||
                            "Decision pending",
                          staffReviewText:
                            aiReview?.staffReviewText ||
                            aiReview?.staffReview ||
                            aiResult?.staffReviewText ||
                            aiResult?.staffReview ||
                            attempt?.staffReviewText ||
                            attempt?.staffReview ||
                            "",
                          approvalConditions:
                            aiReview?.approvalConditions ||
                            aiResult?.approvalConditions ||
                            attempt?.approvalConditions ||
                            [],
                          suggestedRewrite:
                            aiReview?.suggestedRewrite ||
                            aiReview?.rewrite ||
                            aiResult?.suggestedRewrite ||
                            aiResult?.rewrite ||
                            "",
                        }}
                      />
                    </>
                  )}
                </div>
              );
            })
          )}
        </>
      )}
    </div>
  </div>
);
}
